import { StrOrNum } from '../../../types/util';
import { ApplyForProgramsOrScholarshipsRequestPayload } from './types';

export const formatApplyDataForProgramsOrScholarshipsRequest = (
  applyItems: ApplyForProgramsOrScholarshipsRequestPayload['items']
): { apply: StrOrNum[]; secondary_apply: (StrOrNum | undefined)[]; has_program: boolean[] } => {
  const apply: StrOrNum[] = [];
  const secondary_apply: (StrOrNum | undefined)[] = [];
  const has_program: boolean[] = [];
  applyItems.forEach((item) => {
    apply.push(item.apply);
    secondary_apply.push(item.has_program ? item.secondary_apply : undefined);
    has_program.push(item.has_program || false);
  });
  return { apply, secondary_apply, has_program };
};
